export function throwTestException() {
  // testing the tsack trace
  innerFunction()
}

function innerFunction() {
  throw new Error('test')
}
